import React from 'react';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PaymentInfoForm } from '@/modules/partner/model/form';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

type Props = {
  control: Control<PaymentInfoForm>;
};

const UaePaymentInfo: React.FC<Props> = ({ control }) => {
  const intl = useIntl();

  return (
    <>
      <TextField
        name="iban"
        title={intl.formatMessage({
          defaultMessage: 'IBAN',
          id: '3M6gjP',
          description: 'IBAN field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: 'AE070331234567890123456',
          id: 'QYA507',
          description: 'UAE iban field placeholder',
        })}
        control={control}
      />
      <TextField
        name="bik"
        title={intl.formatMessage({
          defaultMessage: 'BIC',
          id: 'TcbaS8',
          description: 'BIC field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: '12345678000',
          id: 'z4Qlja',
          description: 'UAE bic field placeholder',
        })}
        control={control}
      />
    </>
  );
};

export { UaePaymentInfo };
